/**
 * Size drawer controller. Visibility and sizes driven by product tags via body dataset.
 * has_size_ring → sizes 3–14 step 0.5, save to Ring Size
 * has_size_bracelet → sizes XS–XL, save to Bracelet Size
 * No variants, options, or product.type.
 */
// @ts-nocheck
(function () {
  const DRAWER_SELECTOR = '[data-size-drawer]';
  const CLOSE_SELECTORS = '[data-size-drawer-close]';
  const TRIGGER_SELECTOR = '[data-find-your-size]';
  const SIZE_BUTTON_SELECTOR = '.size-drawer__row-btn[data-size-value], .size-drawer__bracelet-row-btn[data-size-value]';
  const RING_INPUT_ID = 'selected-ring-size';
  const BRACELET_INPUT_ID = 'selected-bracelet-size';

  /** Tiffany-style US ring size → Internal Diameter (mm) / Circumference (mm) / UK size */
  const RING_SIZE_CHART = {
    '3': { diameter: 14.1, circumference: 44.2, uk: 'F' },
    '3.5': { diameter: 14.5, circumference: 45.5, uk: 'G ½' },
    '4': { diameter: 14.9, circumference: 46.8, uk: 'H ½' },
    '4.5': { diameter: 15.3, circumference: 48.0, uk: 'I ½' },
    '5': { diameter: 15.7, circumference: 49.3, uk: 'J ½' },
    '5.5': { diameter: 16.1, circumference: 50.6, uk: 'K ½' },
    '6': { diameter: 16.5, circumference: 51.9, uk: 'L ½' },
    '6.5': { diameter: 16.9, circumference: 53.1, uk: 'M ½' },
    '7': { diameter: 17.3, circumference: 54.4, uk: 'N ½' },
    '7.5': { diameter: 17.7, circumference: 55.7, uk: 'O ½' },
    '8': { diameter: 18.2, circumference: 57.0, uk: 'P ½' },
    '8.5': { diameter: 18.6, circumference: 58.3, uk: 'Q ½' },
    '9': { diameter: 19.0, circumference: 59.5, uk: 'R ½' },
    '9.5': { diameter: 19.4, circumference: 60.8, uk: 'S ½' },
    '10': { diameter: 19.8, circumference: 62.1, uk: 'T ½' },
    '10.5': { diameter: 20.2, circumference: 63.4, uk: 'U ½' },
    '11': { diameter: 20.6, circumference: 64.7, uk: 'V ½' },
    '11.5': { diameter: 21.0, circumference: 66.0, uk: 'W ½' },
    '12': { diameter: 21.4, circumference: 67.2, uk: 'Y' },
    '12.5': { diameter: 21.8, circumference: 68.5, uk: 'Z' },
    '13': { diameter: 22.2, circumference: 69.7, uk: 'Z+1' },
    '13.5': { diameter: 22.6, circumference: 71.0, uk: 'Z+2' },
    '14': { diameter: 23.0, circumference: 72.3, uk: 'Z+3' }
  };

  function getDrawer() {
    return document.querySelector(DRAWER_SELECTOR);
  }

  function isRing() {
    if (document.body.dataset.hasRingSize === 'true') return true;
    const container = document.getElementById('size-drawer-container');
    return !!(container && container.getAttribute('data-has-ring-size') === 'true');
  }

  function isBracelet() {
    if (document.body.dataset.hasBraceletSize === 'true') return true;
    const container = document.getElementById('size-drawer-container');
    return !!(container && container.getAttribute('data-has-bracelet-size') === 'true');
  }

  function getHiddenSizeInput() {
    if (isRing()) return document.getElementById(RING_INPUT_ID);
    if (isBracelet()) return document.getElementById(BRACELET_INPUT_ID);
    return document.getElementById(RING_INPUT_ID) || document.getElementById(BRACELET_INPUT_ID);
  }

  function getCurrentSizeValue() {
    const input = getHiddenSizeInput();
    return input ? (input.value || '').trim() : '';
  }

  function syncSelectedState(drawer) {
    const currentValue = getCurrentSizeValue();
    if (!drawer) return;
    drawer.querySelectorAll(SIZE_BUTTON_SELECTOR).forEach(function (btn) {
      const val = (btn.getAttribute('data-size-value') || '').trim();
      btn.classList.toggle('is-selected', val === currentValue);
    });
    drawer.querySelectorAll('tr[data-size-value]').forEach(function (row) {
      const val = (row.getAttribute('data-size-value') || '').trim();
      row.classList.toggle('is-selected', val === currentValue);
    });
  }

  function openDrawer() {
    const drawer = getDrawer();
    if (!drawer) return;

    syncSelectedState(drawer);
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    var content = drawer.querySelector('.size-drawer__content');
    if (content) content.scrollTop = 0;

    var focusTarget = drawer.querySelector('.size-drawer__close') || drawer.querySelector('tr[data-size-value]') || drawer.querySelector(SIZE_BUTTON_SELECTOR);
    if (focusTarget) focusTarget.focus();
  }

  function closeDrawer() {
    const drawer = getDrawer();
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function setSizeAndClose(value, sizeType) {
    const input = sizeType === 'bracelet'
      ? document.getElementById(BRACELET_INPUT_ID)
      : document.getElementById(RING_INPUT_ID);
    if (input) input.value = value || '';

    const drawer = getDrawer();
    if (drawer) {
      drawer.querySelectorAll(SIZE_BUTTON_SELECTOR).forEach(function (btn) {
        const val = (btn.getAttribute('data-size-value') || '').trim();
        btn.classList.toggle('is-selected', val === (value || '').trim());
      });
      drawer.querySelectorAll('tr[data-size-value]').forEach(function (row) {
        const val = (row.getAttribute('data-size-value') || '').trim();
        row.classList.toggle('is-selected', val === (value || '').trim());
      });
    }
    closeDrawer();
  }

  function updateSelectedSizeDisplay(value) {
    document.querySelectorAll('[data-selected-size-value]').forEach(function (display) {
      display.textContent = value || 'Select';
    });
    document.querySelectorAll('[data-size-chip]').forEach(function (chip) {
      const val = (chip.getAttribute('data-size-chip') || '').trim();
      const on = val === (value || '').trim();
      chip.classList.toggle('is-selected', on);
      chip.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function clearSizeRequiredError() {
    const sizeRow = document.querySelector('.variant-option--find-your-size');
    const sizeError = document.querySelector('[data-size-required-error]');
    if (sizeRow) sizeRow.classList.remove('size-required-error');
    if (sizeError) sizeError.classList.add('hidden');
  }

  function getRingSizes() {
    const arr = [];
    for (let s = 3; s <= 14; s += 0.5) {
      arr.push(s % 1 === 0 ? String(s) : s.toFixed(1));
    }
    return arr;
  }

  function getBraceletSizes() {
    return ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
  }

  /** Bracelet size → length (inches) for premium row display */
  const BRACELET_LENGTH = { XS: '6"', S: '6.5"', M: '7"', L: '7.5"', XL: '8"', XXL: '8.5"', XXXL: '9"' };

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function injectSizeButtons(drawer) {
    if (!drawer) return;
    if (isRing()) {
      const tbody = drawer.querySelector('tbody[data-dynamic-sizes="ring"]');
      if (tbody && tbody.children.length === 0) {
        const sizes = getRingSizes();
        tbody.innerHTML = '';
        sizes.forEach(function (size) {
          const chart = RING_SIZE_CHART[size];
          const diamCirc = chart
            ? chart.diameter + ' / ' + chart.circumference
            : '';
          const uk = chart ? chart.uk : '';
          const tr = document.createElement('tr');
          tr.innerHTML =
            '<td><button type="button" class="size-drawer__row-btn button-unstyled" data-size-value="' +
            escapeHtml(size) +
            '"><span class="size-drawer__row-num">' +
            escapeHtml(size) +
            '</span></button></td><td>' +
            escapeHtml(diamCirc) +
            '</td><td>' +
            escapeHtml(uk) +
            '</td>';
          tbody.appendChild(tr);
        });
      }
    }
    if (isBracelet()) {
      const tbody = drawer.querySelector('tbody[data-dynamic-sizes="bracelet"]');
      if (tbody && tbody.children.length === 0) {
        const sizes = getBraceletSizes();
        tbody.innerHTML = '';
        sizes.forEach(function (size) {
          const length = BRACELET_LENGTH[size] || '';
          const tr = document.createElement('tr');
          tr.setAttribute('data-size-value', size);
          tr.setAttribute('role', 'button');
          tr.setAttribute('tabindex', '0');
          tr.setAttribute('aria-label', 'Select size ' + size + ', ' + length + ' length');
          tr.innerHTML =
            '<td><span class="size-drawer__bracelet-size-label">' + escapeHtml(size) + '</span></td><td class="size-drawer__bracelet-length">' +
            escapeHtml(length) +
            '</td>';
          tbody.appendChild(tr);
        });
      }
    }
  }

  /* ============================================================
     On-screen calibrated ruler + "place your ring" circle sizer
     Calibrated via a bank card (ISO/IEC 7810 ID-1 = 85.60 x 53.98 mm).
     Stores the result as device pixels-per-mm (orientation-independent),
     so Landscape (long side) and Portrait (short side, fits phones)
     calibration share the same accuracy.
     ============================================================ */
  const CARD_LONG_MM = 85.6;
  const CARD_SHORT_MM = 53.98;
  const RULER_STORAGE_KEY = 'silvify_ruler_px_per_mm';
  // Nominal CSS reference: 96px per inch → mm = 96 / 25.4 ≈ 3.7795 px
  const DEFAULT_PX_PER_MM = 96 / 25.4;

  function loadPxPerMm() {
    let ppmm = DEFAULT_PX_PER_MM;
    try {
      const saved = parseFloat(localStorage.getItem(RULER_STORAGE_KEY));
      if (!isNaN(saved) && saved > 0) ppmm = saved;
    } catch (_) {}
    return ppmm;
  }

  function savePxPerMm(ppmm) {
    try {
      localStorage.setItem(RULER_STORAGE_KEY, String(ppmm));
    } catch (_) {}
  }

  /* Scale presets used by renderScale (positions computed in mm → px). */
  const SCALE_CM = { minorMm: 1, mediumEvery: 5, majorEvery: 10, maxMm: 100, labelFn: function (n) { return n / 10; } };
  // 1 inch = 25.4 mm; minor = 1/8", medium = 1/2", major = 1"
  const SCALE_INCH = { minorMm: 25.4 / 8, mediumEvery: 4, majorEvery: 8, maxMm: 25.4 * 10, labelFn: function (n) { return n / 8; } };

  /**
   * Wire the shared card-calibration UI inside a ruler container.
   * Calls onCalibrated(pxPerMm) on init and on every change. Returns a re-render fn.
   */
  function wireCalibration(ruler, onCalibrated) {
    const card = ruler.querySelector('[data-ruler-card]');
    const slider = ruler.querySelector('[data-ruler-slider]');
    const resetBtn = ruler.querySelector('[data-ruler-reset]');
    const orientBtns = ruler.querySelectorAll('[data-ruler-orient]');
    if (!card || !slider) return function () {};

    const sliderMin = parseFloat(slider.min) || 140;
    const sliderMax = parseFloat(slider.max) || 760;
    let ppmm = loadPxPerMm();
    // Default to portrait on small screens where a full-length card can't fit.
    let orientation = (window.matchMedia && window.matchMedia('(max-width: 600px)').matches) ? 'portrait' : 'landscape';

    function refMm() {
      return orientation === 'portrait' ? CARD_SHORT_MM : CARD_LONG_MM;
    }

    function clampWidth(w) {
      if (w < sliderMin) return sliderMin;
      if (w > sliderMax) return sliderMax;
      return w;
    }

    function applyCard() {
      card.classList.toggle('size-ruler__card--portrait', orientation === 'portrait');
      const w = clampWidth(ppmm * refMm());
      card.style.width = w + 'px';
      const wRounded = String(Math.round(w));
      if (slider.value !== wRounded) slider.value = wRounded;
      orientBtns.forEach(function (b) {
        b.classList.toggle('size-ruler__orient-btn--active', b.getAttribute('data-ruler-orient') === orientation);
      });
    }

    function update() {
      applyCard();
      if (onCalibrated) onCalibrated(ppmm);
    }

    slider.addEventListener('input', function () {
      const w = parseFloat(slider.value) || (DEFAULT_PX_PER_MM * refMm());
      ppmm = w / refMm();
      savePxPerMm(ppmm);
      update();
    });

    orientBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        orientation = btn.getAttribute('data-ruler-orient') === 'portrait' ? 'portrait' : 'landscape';
        update();
      });
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        ppmm = DEFAULT_PX_PER_MM;
        savePxPerMm(ppmm);
        update();
      });
    }

    update();
    return update;
  }

  /** Render an accurate, true-to-size tick scale (cm or inch), horizontal or vertical. */
  function renderScale(scaleEl, ppmm, opts, vertical) {
    if (!scaleEl) return;
    scaleEl.classList.toggle('size-ruler__scale--vertical', !!vertical);
    let html = '';
    const eps = 1e-6;
    for (let n = 0; n * opts.minorMm <= opts.maxMm + eps; n++) {
      const mm = n * opts.minorMm;
      const pos = (mm * ppmm).toFixed(2);
      let cls = 'size-ruler__tick';
      if (n % opts.majorEvery === 0) cls += ' size-ruler__tick--major';
      else if (n % opts.mediumEvery === 0) cls += ' size-ruler__tick--medium';
      const style = vertical ? 'top:' + pos + 'px' : 'left:' + pos + 'px';
      html += '<span class="' + cls + '" style="' + style + '"></span>';
      if (n % opts.majorEvery === 0) {
        html += '<span class="size-ruler__tick-label" style="' + style + '">' + opts.labelFn(n) + '</span>';
      }
    }
    const lengthPx = (opts.maxMm * ppmm + 2) + 'px';
    if (vertical) {
      scaleEl.style.height = lengthPx;
      scaleEl.style.width = '';
    } else {
      scaleEl.style.width = lengthPx;
      scaleEl.style.height = '';
    }
    scaleEl.innerHTML = html;
  }

  function setupRingRuler(root) {
    if (!root) return;
    const section = root.matches && root.matches('[data-size-type="ring"]')
      ? root
      : root.querySelector('[data-size-type="ring"]');
    const ruler = section ? section.querySelector('[data-size-ruler]') : null;
    if (!ruler || ruler.dataset.rulerReady === 'true') return;
    ruler.dataset.rulerReady = 'true';

    const circleEl = ruler.querySelector('[data-ruler-circle]');
    const sizeLabel = ruler.querySelector('[data-ruler-size-label]');
    const sizeDetail = ruler.querySelector('[data-ruler-size-detail]');
    const prevBtn = ruler.querySelector('[data-ruler-prev]');
    const nextBtn = ruler.querySelector('[data-ruler-next]');
    const selectBtn = ruler.querySelector('[data-ruler-select]');
    const scaleEl = ruler.querySelector('[data-ruler-scale]');

    const sizes = getRingSizes().filter(function (s) { return RING_SIZE_CHART[s]; });
    let circleIndex = Math.max(0, sizes.indexOf('7'));
    if (circleIndex < 0) circleIndex = Math.floor(sizes.length / 2);
    let lastPpmm = DEFAULT_PX_PER_MM;

    function renderCircle() {
      if (!circleEl) return;
      const size = sizes[circleIndex];
      const chart = RING_SIZE_CHART[size];
      if (!chart) return;
      circleEl.style.width = (chart.diameter * lastPpmm) + 'px';
      circleEl.style.height = (chart.diameter * lastPpmm) + 'px';
      circleEl.setAttribute('data-size-value', size);
      if (sizeLabel) sizeLabel.textContent = 'US ' + size;
      if (sizeDetail) sizeDetail.textContent = chart.diameter + ' mm diameter · UK ' + chart.uk;
    }

    wireCalibration(ruler, function (ppmm) {
      lastPpmm = ppmm;
      renderCircle();
      renderScale(scaleEl, ppmm, SCALE_CM);
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (circleIndex > 0) { circleIndex--; renderCircle(); }
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (circleIndex < sizes.length - 1) { circleIndex++; renderCircle(); }
      });
    }
    if (selectBtn) {
      selectBtn.addEventListener('click', function () {
        const value = sizes[circleIndex];
        setSizeAndClose(value, 'ring');
        updateSelectedSizeDisplay(value);
        clearSizeRequiredError();
      });
    }

    ruler.querySelectorAll('[data-ruler-mode]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const mode = btn.getAttribute('data-ruler-mode');
        ruler.querySelectorAll('[data-ruler-mode]').forEach(function (b) {
          b.classList.toggle('size-ruler__mode--active', b === btn);
        });
        ruler.querySelectorAll('[data-ruler-view]').forEach(function (v) {
          v.hidden = v.getAttribute('data-ruler-view') !== mode;
        });
        if (mode === 'ruler') renderScale(scaleEl, lastPpmm, SCALE_CM);
      });
    });
  }

  function setupBraceletRuler(root) {
    if (!root) return;
    const section = root.matches && root.matches('[data-size-type="bracelet"]')
      ? root
      : root.querySelector('[data-size-type="bracelet"]');
    const ruler = section ? section.querySelector('[data-size-ruler]') : null;
    if (!ruler || ruler.dataset.rulerReady === 'true') return;
    ruler.dataset.rulerReady = 'true';

    const scaleEl = ruler.querySelector('[data-ruler-scale]');
    wireCalibration(ruler, function (ppmm) {
      renderScale(scaleEl, ppmm, SCALE_INCH, true);
    });
  }

  function switchMeasureTab(section, tabId) {
    if (!section || !tabId) return;
    const isBraceletSection = section.getAttribute('data-size-type') === 'bracelet';
    const prefix = isBraceletSection ? 'tab-bracelet-' : 'tab-';
    section.querySelectorAll('.size-drawer__tab').forEach(function (t) {
      t.classList.remove('size-drawer__tab--active');
      t.setAttribute('aria-selected', 'false');
    });
    section.querySelectorAll('.size-drawer__tab-panel').forEach(function (p) {
      p.classList.remove('size-drawer__tab-panel--active');
      p.hidden = true;
    });
    const tab = section.querySelector('.size-drawer__tab[data-tab="' + tabId + '"]');
    if (tab) {
      tab.classList.add('size-drawer__tab--active');
      tab.setAttribute('aria-selected', 'true');
    }
    const panel = section.querySelector('#' + prefix + tabId);
    if (panel) {
      panel.classList.add('size-drawer__tab-panel--active');
      panel.hidden = false;
    }
  }

  function initPageMeasureTools() {
    const root = document.querySelector('[data-size-guide-measure]');
    if (!root) return;

    const ringSection = root.querySelector('[data-size-type="ring"]');
    const braceletSection = root.querySelector('[data-size-type="bracelet"]');
    if (ringSection) setupRingRuler(ringSection);
    if (braceletSection) setupBraceletRuler(braceletSection);

    root.querySelectorAll('[data-guide-type]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const type = btn.getAttribute('data-guide-type');
        root.querySelectorAll('[data-guide-type]').forEach(function (b) {
          const active = b === btn;
          b.classList.toggle('size-guide-measure__type-tab--active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        root.querySelectorAll('[data-guide-panel]').forEach(function (panel) {
          const show = panel.getAttribute('data-guide-panel') === type;
          panel.hidden = !show;
          panel.classList.toggle('size-guide-measure__panel--active', show);
        });
      });
    });
  }

  function init() {
    const drawer = getDrawer();

    if (drawer && (isRing() || isBracelet())) {
      injectSizeButtons(drawer);
      if (isRing()) setupRingRuler(drawer);
      if (isBracelet()) setupBraceletRuler(drawer);

      var currentSize = getCurrentSizeValue();
      if (currentSize) updateSelectedSizeDisplay(currentSize);

      document.addEventListener('click', function (e) {
        if (e.target.closest(TRIGGER_SELECTOR)) {
          e.preventDefault();
          openDrawer();
          return;
        }

        if (e.target.closest(CLOSE_SELECTORS)) {
          e.preventDefault();
          closeDrawer();
          return;
        }

        const braceletRow = e.target.closest('tr[data-size-value]');
        if (braceletRow && drawer.contains(braceletRow)) {
          e.preventDefault();
          const value = (braceletRow.getAttribute('data-size-value') || '').trim();
          setSizeAndClose(value, 'bracelet');
          updateSelectedSizeDisplay(value);
          clearSizeRequiredError();
          return;
        }

        const sizeBtn = e.target.closest(SIZE_BUTTON_SELECTOR);
        if (sizeBtn && drawer.contains(sizeBtn)) {
          const value = (sizeBtn.getAttribute('data-size-value') || '').trim();
          const section = sizeBtn.closest('.size-drawer__section');
          const sizeType = section && section.getAttribute('data-size-type') === 'bracelet' ? 'bracelet' : 'ring';
          setSizeAndClose(value, sizeType);
          updateSelectedSizeDisplay(value);
          clearSizeRequiredError();
        }
      });

      drawer.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          if (drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
          return;
        }
        var row = e.target.closest('tr[data-size-value]');
        if (row && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          var value = (row.getAttribute('data-size-value') || '').trim();
          setSizeAndClose(value, 'bracelet');
          updateSelectedSizeDisplay(value);
          clearSizeRequiredError();
        }
      });
    }

    // Measure method tabs (product drawer + size guide page)
    document.addEventListener('click', function (e) {
      const tab = e.target.closest('.size-drawer__tab[data-tab]');
      if (!tab) return;
      e.preventDefault();
      const section = tab.closest('.size-drawer__section');
      if (!section) return;
      switchMeasureTab(section, tab.getAttribute('data-tab'));
    });

    initPageMeasureTools();

    document.addEventListener('click', function (e) {
      const chip = e.target.closest('[data-size-chip]');
      if (!chip) return;
      e.preventDefault();
      const value = (chip.getAttribute('data-size-chip') || '').trim();
      const sizeType = chip.getAttribute('data-size-type') === 'bracelet' ? 'bracelet' : 'ring';
      const input = sizeType === 'bracelet'
        ? document.getElementById(BRACELET_INPUT_ID)
        : document.getElementById(RING_INPUT_ID);
      if (input) input.value = value;
      updateSelectedSizeDisplay(value);
      clearSizeRequiredError();
    });

    document.addEventListener('variant:update', function () {
      setTimeout(function () {
        const nextDrawer = getDrawer();
        if (nextDrawer && (isRing() || isBracelet())) {
          injectSizeButtons(nextDrawer);
          syncSelectedState(nextDrawer);
        }
        var currentSize = getCurrentSizeValue();
        if (currentSize) updateSelectedSizeDisplay(currentSize);
      }, 50);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
